import { FieldDataType } from 'mapistry-shared';

export const versionableFieldTypes = [
  FieldDataType.BOOLEAN,
  FieldDataType.DATETIME,
  FieldDataType.TEXT,
  FieldDataType.NUMERIC,
  FieldDataType.SINGLE_SELECT,
  FieldDataType.RESOURCE,
];
